export const getPercentage = (
  number: number,
  total: number,
  decimals = 0
): string => {
  return `${((number / total) * 100).toFixed(decimals)}%`
}
